import { render } from "./Pause.vue?vue&type=template&id=4cd2cd0a&scoped=true"
import script from "./Pause.vue?vue&type=script&lang=js"
export * from "./Pause.vue?vue&type=script&lang=js"

import "./Pause.vue?vue&type=style&index=0&id=4cd2cd0a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd2cd0a"]])

export default __exports__